import styled, { css } from 'styled-components';
import tw from 'twin.macro';

import { colors as Colors } from '../../themes/Colors';

export const OTPFieldContainer = styled.div`
  ${tw`flex flex-col items-center w-full`}
  ${(props) => props.css}
`;

export const OTPBoxesFieldContainer = styled.div`
  .otp-input {
    width: 42px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    margin-right: 14px;
    font-family: Inter;
    ${tw`rounded-lg text-sm font-medium`}
    /* Remove mobile tap highlight to prevent persistent focus state */
    -webkit-tap-highlight-color: transparent;

    &:last-child {
      margin-right: 0px !important;
    }
  }
  .otp-input-focus {
    background: #ffffff;
    opacity: 0.9;
    border: 1px solid #2563eb;
    ${tw`outline-none`};
  }
  .otp-input-focus:focus {
    ${tw`ring-4 ring-blue-200`}
  }
  .otp-error {
    border: 1px solid #dc2626;
    color: #dc2626;
  }
  .otp-error:focus {
    ${tw`ring-4 ring-red-200`}
  }
  ${(props) => props.css}
`;

export const ResendOTPWithTimerContainer = styled.div`
  ${tw`flex justify-center w-full`}
`;

export const ResendOTPWithOTPTimerContainer = styled(
  ResendOTPWithTimerContainer
)`
  align-items: center;
`;

export const OTPTimerText = styled.span`
  ${tw`text-xs leading-4 text-blue-gray-700 select-none text-right font-inter`}
`;

export const ResendButton = styled.button`
  ${tw`flex items-center bg-transparent right-0 outline-none`}
`;

export const ResendOTPAndCallContainer = styled.div`
  ${tw`flex flex-col items-center`}
`;

export const ResendOTPTextContainer = styled.div`
  ${tw`flex cursor-pointer`}
  ${(props) => props.isDisabled && tw`cursor-not-allowed`}
`;

export const IconWrapper = styled.div`
  ${tw`mr-2`}
`;

export const ResendOTPText = styled.span`
  ${tw`pointer-events-none text-xs leading-4 font-inter`};
  padding-left: auto;
  margin-right: 5px;
  ${(props) => (!props.disabled ? tw`text-blue-600` : tw`text-blue-gray-400`)};
`;

export const OrText = styled.div`
  ${tw`text-xs  leading-4  font-normal mt-1 mb-1`}
  color:${Colors['light-blue-gray-600']}
`;

export const errorMessageStylesCss = css`
  ${tw`mb-6 text-center`};
  max-width: 210px;
  margin-top: 17px;
`;

export const ResendOtpButtonAwayFromTimerContainer = styled.div`
  ${tw`flex justify-between items-center w-full mb-6`};
`;

export const ResendOtpButtonAwayFromTimer = styled.button`
  ${tw`bg-transparent text-sm leading-5 font-medium`};
  ${(props) =>
    props.disabled
      ? tw`text-blue-gray-400 pointer-events-none`
      : tw`text-blue-600`}
`;

export const TimeUp = styled.span`
  ${tw`text-sm leading-5 font-medium text-blue-gray-400`}
`;
